import services from 'services/services';
import * as types from '../types';
import { setRequestUrl } from 'store/actions';

// Import helpers
import {
	checkFetchErrors,
	queryParams
} from '../helpers_actions/convert_helpers';

// Import variables
import { TABLE_LENGTH } from 'components/helpers/table';

// ******************** FETCH EVENTS LIVE - TABLE DATA ********************
export const fetchEventsLive = (options) => async (dispatch, getState) => {
	try {
		// Dispatch a loading action
		dispatch({
			type: types.FETCH_EVENTS_LIVE_LOADING,
			payload: true
		});

		const {
			events_live: {
				table: {
					columns,
					options: {
						filters: { filterUrlQuery },
						startIndex: startTableIndex,
						page
					}
				}
			}
		} = getState();

		const startIndex =
			options.page === page ? startTableIndex : options.startIndex;

		// To do: change to events live url
		const url = `/products/liveevents/list?${filterUrlQuery}${queryParams(
			options,
			TABLE_LENGTH,
			columns,
			startIndex
		)}`;

		const { data } = await services.get(url);
		// Calculate pages
		const pages = Math.ceil(data.recordsFiltered / TABLE_LENGTH);

		// Dispatch an action with data
		dispatch({
			type: types.FETCH_EVENTS_LIVE_SUCCESS,
			payload: { ...data, pages, page: options.page, startIndex }
		});

		// save request url in redux
		setRequestUrl(url)(dispatch);
	} catch (error) {
		dispatch({
			type: types.FETCH_EVENTS_LIVE_ERROR,
			payload: checkFetchErrors(error)
		});
	}
};

// ******************** DELETE EVENT LIVE ********************
export const deleteEventLive = (id) => async (dispatch) => {
	try {
		// Dispatch a loading action
		dispatch({
			type: types.DELETE_EVENT_LIVE_LOADING,
			payload: true
		});

		// To do: change to event live url
		await services.delete(`/products/liveevents/${id}`);
		// Dispatch an action with data
		dispatch({
			type: types.DELETE_EVENT_LIVE_SUCCESS,
			payload: true
		});
	} catch (error) {
		// Dispatch an action with error set to true
		dispatch({
			type: types.DELETE_EVENT_LIVE_ERROR,
			payload: checkFetchErrors(error)
		});
	}
};

// ******************** SET SEARCH QUERY ********************
export const setEventsLiveQuery = (query) => ({
	type: types.SET_EVENTS_LIVE_SEARCH_QUERY,
	payload: query
});
